import * as v from 'valibot';

import { newSchema } from '../../../utils/valibot/schema';

export const VersionSchema = newSchema(
  'VersionSchema',
  v.object({
    'customer-data-frontend': v.pipe(v.string(), v.nonEmpty()),
  }),
);

export type Version = v.InferOutput<typeof VersionSchema>;
